import React from "react"
import { Switch } from "antd"
import { truncate } from "lodash"
import pencilBlue from "../../images/pencil-blue.svg"
import removeIcon from "../../images/remove_icon.svg"
import { buttonAction_btns } from "../Snowplow/config2"

export default (
  users,
  switchUserWatcher,
  userDelete,
  userSelected,
  company_id,
  loading,
  disabled
) => {
  return [
    {
      title: "Nombre",
      width: 380,
      dataIndex: "first_name",
      key: "first_name",
      render: (text, record) => {
        return truncate(
          `${text} ${record.last_name} ${record.second_last_name}`,
          { length: 45 }
        )
      },
    },
    {
      title: "Email",
      width: 260,
      dataIndex: "email",
      key: "email",
      render: (text, record) => {
        return truncate(text, { length: 32 })
      },
    },
    {
      title: "Superadministrador",
      width: 450,
      render: (_, record) => {
        let verifyIsLastAdmin =
          users.filter((e) => e.isCompanySuperAdmin).length === 1 &&
          record.isCompanySuperAdmin
        verifyIsLastAdmin = disabled === true ? disabled : verifyIsLastAdmin
        return (
          <div className="container-usermanagement__superadmin-actions">
            <React.Fragment>
              <Switch
                loading={loading}
                disabled={verifyIsLastAdmin}
                checked={record.isCompanySuperAdmin}
                onChange={(e) =>
                  switchUserWatcher({
                    idUser: record.id,
                    is_superadmin: Number(e),
                    company_id,
                    users,
                  })
                }
                style={{ marginRight: 10 }}
              />

              <div className="container-usermanagement__superadmin-actions-right">
                <img
                  src={pencilBlue}
                  onClick={() => {
                    userSelected(record)
                    buttonAction_btns("Editar administrador")
                  }}
                  style={{
                    width: 16,
                    height: 16,
                    marginRight: 11,
                    cursor: "pointer",
                    opacity: disabled ? "0.4" : 1,
                  }}
                />
                <img
                  src={removeIcon}
                  onClick={() =>
                    verifyIsLastAdmin ? null : userDelete(record)
                  }
                  style={{
                    width: 16,
                    height: 16,
                    cursor: verifyIsLastAdmin ? "not-allowed" : "pointer",
                    opacity: verifyIsLastAdmin ? "0.4" : 1,
                  }}
                />
              </div>
            </React.Fragment>
          </div>
        )
      },
    },
  ]
}
